import React from 'react';

import _ from 'lodash';
import { Redirect } from 'react-router-dom';
import { createClient } from 'contentful';

import request, { getEnvironment } from './utils/request';

export const contentfulFormConfig = {
  include: 8,
  limit: 1000,
  content_type: 'formsContainer'
};

class ContentfulService {
  static instance;

  client = null;

  constructor(credentials) {
    if (ContentfulService.instance) {
      return ContentfulService.instance;
    }
    this.client = createClient(credentials);
    ContentfulService.instance = this;
  }
}

const checkUser = async () => {
  try {
    if (!localStorage.getItem('userProfile')) {
      return await request.get('/users/profile');
    }
    return null;
  } catch (err) {
    return <Redirect to="/login" />;
  }
};

export const getContentfulData = async (config, entryID) => {
  try {
    await checkUser();
    const { contentfulConfig } = getEnvironment();
    const contentfulService = new ContentfulService(contentfulConfig);
    const { client } = contentfulService;
    return entryID
      ? client.getEntry(entryID, config)
      : client.getEntries(config);
  } catch (err) {
    throw new Error(err);
  }
};

export const getData = data =>
  data && data.items && data.items.length && data.items[0].fields;

export const getFormStepFields = (config, setData) => {
  getContentfulData(config).then(res => {
    const { formCategories } = getData(res);
    const categoryBusinessConnect = formCategories.find(
      category =>
        _.get(category, 'fields.name', '') ===
        'TELUS Business Connect Quote Tool/Order Form'
    );

    const {
      fields: { forms }
    } = categoryBusinessConnect;

    if (forms && forms.length >= 3) {
      const {
        fields: { steps }
      } = forms[2];
      if (steps && steps.length) {
        const {
          fields: { formStepFields }
        } = steps[0];
        setData(formStepFields);
      }
    }
  });
};

export const getFormStepFieldsIoT = (config, summaryFormStepIndex, setData) => {
  getContentfulData(config).then(res => {
    const { formCategories } = getData(res);

    const categoryIot = formCategories.find(
      category => _.get(category, 'fields.name', '') === 'TELUS IOT'
    );

    const iotOrderSummaryFrom = _.get(categoryIot, 'fields.forms', []).find(
      form => _.get(form, 'fields.name', '') === 'Order Summary'
    );

    const formStep = _.get(
      iotOrderSummaryFrom,
      `fields.steps.${summaryFormStepIndex}.fields.formStepFields`,
      []
    );

    setData(formStep);
  });
};

export const getBusinessAppFormStepFields = (config, setData) => {
  getContentfulData(config).then(res => {
    const { formCategories } = getData(res);
    const categoryBusinessConnect = formCategories.find(
      category => _.get(category, 'fields.name', '') === 'TELUS Business Apps'
    );
    const {
      fields: { forms }
    } = categoryBusinessConnect;

    if (forms && forms.length >= 2) {
      const {
        fields: { steps }
      } = forms[1];
      if (steps && steps.length) {
        const {
          fields: { formStepFields }
        } = steps[1];
        setData(formStepFields);
      }
    }
  });
};
